import { Envs } from '../../envs'

export class MakeUpsellUrl {
  public execute(offerId: string) {
    return `${Envs.PAY_URL}/${offerId}/upsell`
  }
}
